export { StoreLocator } from './StoreLocator';
